import { createSlice, current } from '@reduxjs/toolkit';
import { EXTERNAL_USER } from '../../actions/ExternalUser/actionExternalUserTypes';

const initialState = {
  externalUser: {
    isLoading: false,
    externalUserData: [],
    consentData: {
      consent: [],
      errors: '',
      message: '',
      isLoading: false
    },
    imageData: {
      errors: '',
      message: '',
      isLoading: false,
      statusCode: ''
    },
    evaluationData: {
      evaluation: [],
      errors: '',
      message: '',
      isLoading: false
    },
    questionData: {
      question: [],
      errors: '',
      message: '',
      isLoading: false
    },
    saveData: {
      statusCode: '',
      errors: '',
      message: '',
      isLoading: false
    },
    questionSave: {
      question: [],
      errors: '',
      message: '',
      isLoading: false
    },
    externalDeviceData: {
      externalDevices: [],
      errors: '',
      message: '',
      isLoading: false
    },
    imagesFromSkillInsightAppData: {
      imagesFromSkillInsightApp: [],
      errors: '',
      message: '',
      isLoading: false
    },
    externalImageStore: {
      imagesFromExternalImageStore: [],
      errors: '',
      message: '',
      isLoading: false
    },
    externalUserEmailEncrypt: {
      externalUserEmailEncryptedData: '',
      errors: '',
      message: '',
      isLoading: false
    },
    sendMailForHRData: {
      errors: '',
      message: '',
      isLoading: false,
      statusCode: ''
    },
    errors: '',
    message: ''
  }
};

export const externalUserSlice = createSlice({
  name: EXTERNAL_USER,
  initialState,
  reducers: {
    getExternalUserAction: (state) => {
      state.externalUser.isLoading = true;
      state.externalUser.errors = '';
      state.externalUser.message = '';
    },
    getExternalUserSuccessAction: (state, action) => {
      state.externalUser.errors = '';
      state.externalUser.message = '';
      if (action.payload) {
        state.externalUser.externalUserData = action.payload;
      }
      state.externalUser.isLoading = false;
    },
    getExternalUserFailureAction: (state, action) => {
      state.externalUser.message = '';
      state.externalUser.isLoading = false;
      state.externalUser.errors = action.payload;
    },

    setExternalUserAction: (state) => {
      state.externalUser.isLoading = true;
      state.externalUser.errors = '';
      state.externalUser.message = '';
    },
    setExternalUserSuccessAction: (state, action) => {
      state.externalUser.message = '';
      state.externalUser.errors = '';
      state.externalUser.message = 'Saved Successfully';
      state.externalUser.isLoading = false;
    },
    setExternalUserFailureAction: (state, action) => {
      state.externalUser.errors = '';
      state.externalUser.message = '';
      state.externalUser.isLoading = false;
      state.externalUser.errors = action.payload;
    },

    // Consent Slicer Start //

    getConsentAction: (state) => {
      state.externalUser.consentData.isLoading = true;
      state.externalUser.consentData.errors = '';
    },
    getConsentSuccessAction: (state, action) => {
      if (action.payload) {
        state.externalUser.consentData.consent = action.payload;
      }
      state.externalUser.consentData.isLoading = false;
    },
    getConsentFailureAction: (state, action) => {
      state.externalUser.consentData.isLoading = false;
      state.externalUser.consentData.errors = action.payload;
    },

    setConsentAction: (state) => {
      state.externalUser.consentData.isLoading = true;
      state.externalUser.consentData.errors = '';
    },
    setConsentSuccessAction: (state, action) => {
      state.externalUser.consentData.isLoading = false;
      state.externalUser.consentData.errors = '';
      if (action.payload?.data >= 1) {
        state.externalUser.consentData.message = 'Saved Successfully';
      }
    },
    setConsentFailureAction: (state, action) => {
      state.externalUser.consentData.isLoading = false;
      state.externalUser.consentData.errors = action.payload;
    },

    setUserImageAction: (state) => {
      state.externalUser.imageData.isLoading = true;
      state.externalUser.imageData.errors = '';
      state.externalUser.imageData.statusCode = '';
      state.externalUser.imageData.message = '';
    },
    setUserImageSuccessAction: (state, action) => {
      state.externalUser.imageData.isLoading = false;
      state.externalUser.imageData.errors = '';
      state.externalUser.imageData.statusCode = action.payload?.data;
      if (action.payload?.data == 0) {
        state.externalUser.imageData.message = 'Saved Successfully';
      }
    },
    setUserImageFailureAction: (state, action) => {
      state.externalUser.imageData.isLoading = false;
      state.externalUser.imageData.errors = action.payload;
    },

    // Consent Slicer End //

    //EVALUTION Slicer Start //

    getUserEvaluationAction: (state) => {
      state.externalUser.evaluationData.isLoading = true;
      state.externalUser.evaluationData.errors = '';
      state.externalUser.evaluationData.message = '';
    },
    getUserEvaluationSuccessAction: (state, action) => {
      state.externalUser.evaluationData.errors = '';
      state.externalUser.evaluationData.message = '';
      if (action.payload) {
        state.externalUser.evaluationData.evaluation = action.payload;
      }
      state.externalUser.evaluationData.isLoading = false;
    },
    getUserEvaluationFailureAction: (state, action) => {
      state.externalUser.evaluationData.message = '';
      state.externalUser.evaluationData.isLoading = false;
      state.externalUser.evaluationData.errors = action.payload;
    },

    getUserAssessmentAction: (state) => {
      state.externalUser.questionData.isLoading = true;
      state.externalUser.questionData.errors = '';
      state.externalUser.questionData.message = '';
    },
    getUserAssessmentSuccessAction: (state, action) => {
      state.externalUser.questionData.errors = '';
      state.externalUser.questionData.message = '';
      if (action.payload) {
        state.externalUser.questionData.question = action.payload;
      }
      state.externalUser.questionData.isLoading = false;
    },
    getUserAssessmentFailureAction: (state, action) => {
      state.externalUser.questionData.message = '';
      state.externalUser.questionData.isLoading = false;
      state.externalUser.questionData.errors = action.payload;
    },

    setUserAssessmentAction: (state) => {
      state.externalUser.saveData.isLoading = true;
      state.externalUser.saveData.errors = '';
      state.externalUser.saveData.message = '';
    },
    setUserAssessmentSuccessAction: (state, action) => {
      state.externalUser.saveData.errors = '';
      state.externalUser.saveData.message = '';
      if (action.payload) {
        state.externalUser.saveData.statusCode = action.payload.data;
      }
      state.externalUser.saveData.isLoading = false;
    },
    setUserAssessmentFailureAction: (state, action) => {
      state.externalUser.saveData.message = '';
      state.externalUser.saveData.isLoading = false;
      state.externalUser.saveData.errors = action.payload;
    },

    // For saving Assessment Response for internal
    // setQuestionAction: (state) => {
    //   state.externalUser.questionSave.isLoading = true;
    //   state.externalUser.questionSave.errors = '';
    //   state.externalUser.questionSave.message = '';
    // },
    // setQuestionSuccessAction: (state, action) => {
    //   state.externalUser.questionSave.errors = '';
    //   state.externalUser.questionSave.message = '';
    //   if (action.payload.data) {
    //     state.externalUser.questionSave.question = action.payload.data;
    //   }
    //   if (action.payload.navigate) {
    //     const { question } = current(state.externalUser.questionData);
    //     state.externalUser = { ...initialState };
    //     action.payload.navigate(`/UserAnalysis`, {
    //       replace: true,
    //       state: { id: question?.currentCycleId, isAssessor: false }
    //     });
    //   }
    //   state.externalUser.questionSave.isLoading = false;
    // },
    // setQuestionFailureAction: (state, action) => {
    //   state.externalUser.questionSave.message = '';
    //   state.externalUser.questionSave.isLoading = false;
    //   state.externalUser.questionSave.errors = action.payload;
    // },

    saveInternalAssessmentResponseAction: (state) => {
      state.externalUser.questionSave.isLoading = true;
      state.externalUser.questionSave.errors = '';
      state.externalUser.questionSave.message = '';
    },
    saveInternalAssessmentResponseSuccessAction: (state, action) => {
      state.externalUser.questionSave.errors = '';
      state.externalUser.questionSave.message = '';
      if (action.payload.data) {
        state.externalUser.questionSave.question = action.payload.data;
      }
      if (action.payload.navigate) {
        const { question } = current(state.externalUser.questionData);
        state.externalUser = { ...initialState };
        action.payload.navigate(`/UserAnalysis`, {
          replace: true,
          state: { id: question?.currentCycleId, isAssessor: false }
        });
      }
      state.externalUser.questionSave.isLoading = false;
    },
    saveInternalAssessmentResponseFailureAction: (state, action) => {
      state.externalUser.questionSave.message = '';
      state.externalUser.questionSave.isLoading = false;
      state.externalUser.questionSave.errors = action.payload;
    },


    // For saving Assessment Response for external
    saveExternalAssessmentResponseAction: (state) => {
      state.externalUser.questionSave.isLoading = true;
      state.externalUser.questionSave.errors = '';
      state.externalUser.questionSave.message = '';
    },
    saveExternalAssessmentResponseSuccessAction: (state, action) => {
      state.externalUser.questionSave.errors = '';
      state.externalUser.questionSave.message = '';
      if (action.payload.data) {
        state.externalUser.questionSave.question = action.payload.data;
      }
      if (action.payload.navigate) {
        const { question } = current(state.externalUser.questionData);
        state.externalUser = { ...initialState };
        action.payload.navigate(`/UserAnalysis`, {
          replace: true,
          state: { id: question?.currentCycleId, isAssessor: false }
        });
      }
      state.externalUser.questionSave.isLoading = false;
    },
    saveExternalAssessmentResponseFailureAction: (state, action) => {
      state.externalUser.questionSave.message = '';
      state.externalUser.questionSave.isLoading = false;
      state.externalUser.questionSave.errors = action.payload;
    },

    // getAttendedQuestionCountAction: (state) => {
    //   state.externalUser.isLoading = true;
    //   state.externalUser.errors = '';
    // },
    // getAttendedQuestionCountSuccessAction: (state, { payload }) => {
    //   state.externalUser.isLoading = false;
    //   state.externalUser.questionNo = payload;
    // },
    // getAttendedQuestionCountFailureAction: (state, { payload }) => {
    //   state.externalUser.isLoading = false;
    //   state.externalUser.errors = payload;
    // },

    //EVALUTION Slicer End //
    resetExternalUserAction: (state) => {
      state.externalUser.message = '';
      state.externalUser.errors = '';
    },
    // Internal Questions to save
    saveInternalQuestionAction: (state) => {
      state.externalUser.consentData.isLoading = true;
      state.externalUser.consentData.errors = '';
    },
    saveInternalQuestionSuccessAction: (state) => {
      state.externalUser.consentData.isLoading = false;
    },
    saveInternalQuestionFailureAction: (state, action) => {
      state.externalUser.consentData.isLoading = false;
      state.externalUser.consentData.errors = action.payload;
    },

    // External Questions to save
    saveExternalQuestionAction: (state) => {
      state.externalUser.consentData.isLoading = true;
      state.externalUser.consentData.errors = '';
    },
    saveExternalQuestionSuccessAction: (state) => {
      state.externalUser.consentData.isLoading = false;
    },
    saveExternalQuestionFailureAction: (state, action) => {
      state.externalUser.consentData.isLoading = false;
      state.externalUser.consentData.errors = action.payload;
    },

    saveExternalUserDeviceDetail: (state) => {
      state.externalUser.externalDeviceData.isLoading = false;
      state.externalUser.externalDeviceData.errors = '';

    },

    saveExternalUserDeviceDetailsSuccessAction: (state, action) => {
      if (action.payload) {
        state.externalUser.externalDeviceData.externalDevices = action.payload;
      }
      state.externalUser.externalDeviceData.isLoading = false;

    },
    saveExternalUserDeviceDetailsFailureAction: (state, action) => {
      state.externalUser.externalDeviceData.isLoading = false;
      state.externalUser.externalDeviceData.message = '';
      state.externalUser.externalDeviceData.errors = action.payload;
    },

    saveImagesFromSkillInsightApp: (state) => {
      state.externalUser.imagesFromSkillInsightAppData.isLoading = false;
      state.externalUser.imagesFromSkillInsightAppData.errors = '';

    },

    saveImagesFromSkillInsightAppSuccessAction: (state, action) => {
      if (action.payload) {
        state.externalUser.imagesFromSkillInsightAppData.imagesFromSkillInsightApp = action.payload;
      }
      state.externalUser.imagesFromSkillInsightAppData.isLoading = false;

    },
    saveImagesFromSkillInsightAppFailureAction: (state, action) => {
      state.externalUser.imagesFromSkillInsightAppData.isLoading = false;
      state.externalUser.imagesFromSkillInsightAppData.message = '';
      state.externalUser.imagesFromSkillInsightAppData.errors = action.payload;
    },

    setExternalImageStore: (state) => {
      state.externalUser.externalImageStore.isLoading = false;
      state.externalUser.externalImageStore.errors = '';

    },

    setExternalImageStoreSuccessAction: (state, action) => {
      if (action.payload) {
        state.externalUser.externalImageStore.imagesFromExternalImageStore = action.payload;
      }
      state.externalUser.externalImageStore.isLoading = false;

    },
    setExternalImageStoreFailureAction: (state, action) => {
      state.externalUser.externalUserEmailEncrypt.isLoading = false;
      state.externalUser.externalUserEmailEncrypt.message = '';
      state.externalUser.externalUserEmailEncrypt.errors = action.payload;
    },

    getExternalUserEncryptedEmail: (state) => {
      state.externalUser.externalUserEmailEncrypt.isLoading = true;
      state.externalUser.externalUserEmailEncrypt.errors = '';
      state.externalUser.externalUserEmailEncrypt.isLoading = '';

    },

    getExternalUserEncryptEmailSuccessAction: (state, action) => {
      state.externalUser.externalUserEmailEncrypt.errors = '';
      state.externalUser.externalUserEmailEncrypt.message = '';
      if (action.payload) {
        state.externalUser.externalUserEmailEncrypt.externalUserEmailEncryptedData = action.payload;
      }
      state.externalUser.externalUserEmailEncrypt.isLoading = false;
    },
    getExternalUserEncryptEmailFailureAction: (state, action) => {
      state.externalUser.externalUserEmailEncrypt.message  = '';
      state.externalUser.externalUserEmailEncrypt.isLoading = false;
      state.externalUser.externalUserEmailEncrypt.errors = action.payload;
    },

    // Send Mail For HR Actions
    sendMailForHRAction: (state) => {
      state.externalUser.sendMailForHRData.isLoading = true;
      state.externalUser.sendMailForHRData.errors = '';
      state.externalUser.sendMailForHRData.message = '';
      state.externalUser.sendMailForHRData.statusCode = '';
    },
    sendMailForHRSuccessAction: (state, action) => {
      state.externalUser.sendMailForHRData.isLoading = false;
      state.externalUser.sendMailForHRData.errors = '';
      state.externalUser.sendMailForHRData.message = 'Mail sent to HR successfully';
      state.externalUser.sendMailForHRData.statusCode = action.payload?.statusCode || 200;
    },
    sendMailForHRFailureAction: (state, action) => {
      state.externalUser.sendMailForHRData.isLoading = false;
      state.externalUser.sendMailForHRData.message = '';
      state.externalUser.sendMailForHRData.errors = action.payload;
      state.externalUser.sendMailForHRData.statusCode = action.payload?.statusCode || 500;
    }
  }
});

export const {
  getExternalUserAction,
  getExternalUserSuccessAction,
  getExternalUserFailureAction,
  setExternalUserAction,
  setExternalUserSuccessAction,
  setExternalUserFailureAction,
  getConsentAction,
  getConsentSuccessAction,
  getConsentFailureAction,
  setConsentAction,
  setConsentSuccessAction,
  setConsentFailureAction,
  setUserImageAction,
  setUserImageSuccessAction,
  setUserImageFailureAction,
  getUserEvaluationAction,
  getUserEvaluationSuccessAction,
  getUserEvaluationFailureAction,
  getUserAssessmentAction,
  getUserAssessmentSuccessAction,
  getUserAssessmentFailureAction,
  setUserAssessmentAction,
  setUserAssessmentSuccessAction,
  setUserAssessmentFailureAction,

  // For saving Assessment Response for internal user
  // setQuestionAction,
  // setQuestionSuccessAction,
  // setQuestionFailureAction,

  saveInternalAssessmentResponseAction,
  saveInternalAssessmentResponseSuccessAction,
  saveInternalAssessmentResponseFailureAction,

  // For saving Assessment Response for external user
  saveExternalAssessmentResponseAction,
  saveExternalAssessmentResponseSuccessAction,
  saveExternalAssessmentResponseFailureAction,

  resetExternalUserAction,
  // getAttendedQuestionCountAction,
  // getAttendedQuestionCountFailureAction,
  // getAttendedQuestionCountSuccessAction,

  // For saving internal user question
  saveInternalQuestionAction,
  saveInternalQuestionSuccessAction,
  saveInternalQuestionFailureAction,
  
  // For saving external user question
  saveExternalQuestionAction,
  saveExternalQuestionSuccessAction,
  saveExternalQuestionFailureAction,

  saveExternalUserDeviceDetail,
  saveExternalUserDeviceDetailsFailureAction,
  saveExternalUserDeviceDetailsSuccessAction,
  saveImagesFromSkillInsightApp,
  saveImagesFromSkillInsightAppSuccessAction,
  saveImagesFromSkillInsightAppFailureAction,
  setExternalImageStore,
  setExternalImageStoreSuccessAction,
  setExternalImageStoreFailureAction,
  getExternalUserEncryptedEmail,
  getExternalUserEncryptEmailSuccessAction,
  getExternalUserEncryptEmailFailureAction,
  sendMailForHRAction,
  sendMailForHRSuccessAction,
  sendMailForHRFailureAction
} = externalUserSlice.actions;

export default externalUserSlice.reducer;